export default __webpack_public_path__ + "static/media/warning.ede57886.jpg";